<button
  type="button"
  class="btn btn-outline-secondary h-100 m-0 app-lookup-button"
  [disabled]="disabled"
  (click)="openLookupModal(officeField)">
  <i class="oi oi-magnifying-glass"></i>
</button>
